<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4 bg-faded">
        <h1 class="text-center fw-400 mb-4 d-xs-block">
          Potwierdzanie konta
        </h1>

        <password-form button-text="Potwierdź" @setPassword="confirmAccount" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PasswordForm from '@/components/forms/PasswordForm';
import { Errors } from '@/enums/errors.enum';
import { authResource } from '@/resources/auth.resource';

// @vuese
// Potwierdzanie konta
// @group StartRoute
export default {
  name: 'ConfirmAccount',
  components: {
    PasswordForm
  },
  computed: mapState({ appTitle: state => state.system.appTitle }),
  mounted() {
    document.title = 'Potwierdzanie konta' + ' - ' + this.appTitle;
  },
  methods: {
    // @vuese
    // Potwierdza konto
    confirmAccount(password) {
      authResource
        .confirm(this.$route.params.token, password)
        .then(() =>
          this.$store.commit('showConfirm', {
            title: 'Konto zostało potwierdzone',
            showCloseButton: false,
            submitButton: 'Ok',
            onSuccess: () => this.$router.push({ name: 'login' })
          })
        )
        .catch(() => this.$store.dispatch('notifyError', { title: Errors.ACCOUNT_CANNOT_CONFIRM }));
    }
  }
};
</script>
